export default {
    'eventUser.event_id': ['stages', 'filterStages', 'id'],
    'groups.id': [
        'storeFilters.occupationGroups',
        'filterOccupationGroups',
        'value',
    ],
    manager_id: ['storeFilters.managers', 'filterManagers', 'value'],
    'status.id': ['storeFilters.status', 'filterStatus', 'value'],
}
